import ajax from '@/utils/ajax'

/**
 * @module 工作台接口
 */

 const BASE_URL = '/workBench'

// 获取待办事项数据
export const getToDoList = () => ajax.post(`${BASE_URL}/getToDoList`)

// 获取常用功能列表
export const getCommonFunctiont = () => ajax.post(`${BASE_URL}/getCommonFunction`)

// 获取今日订单实时数据汇总
export const getCurDateRealTimeData = () => ajax.post(`${BASE_URL}/getCurDateRealTimeData`)

// 获取最新站内信(TOP5)
export const getStationLetterTopFive = () => ajax.post('workBenchNew/getStationLetterTopFive')

// 会员营销画像列表接口
export const recommendPortrayal = params => ajax.post('/portrayal/recommendPortrayal', params)

// 立即发券校验
export const preCheck = params => ajax.post('/marketTask/preCheck', params)

// 油站学堂列表
export const goodsList = params => ajax.post('/starlink/school/goodsList', params)

// 经营状况数据
export const conditionData = params => ajax.post('/workBench/dataIndex', params)

// 经营状况画像
export const conditionDraw = params => ajax.post('/portrayal/workBenchRecommendPortrayal', params)

// 单位
export const conditionUnit = params => ajax.post('/account/unitInfo', params)

